var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftGoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 117,
    viewBox: "0 0 97 117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    x2: "98.699%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A37520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EDE67B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "49.35%",
    x2: "49.35%",
    y1: ".65%",
    y2: "99.35%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A37520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EDE67B"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E7E7",
    d: "M96.772 111.768c0 2.39-19.755 4.329-44.123 4.329s-44.122-1.938-44.122-4.329c0-2.39 19.754-4.329 44.122-4.329s44.123 1.938 44.123 4.329"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M19.98 66.6v37.517c0 4.109 3.393 7.438 7.576 7.438h17.677l5.05-27.601-5.05-17.354H19.98zM59.995 66.6l-5.05 17.354 5.05 27.601h17.677c4.185 0 7.576-3.33 7.576-7.438V66.6H59.995z",
    transform: "translate(.868 .879)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M43.956 111.555h15.318V66.6H43.956z",
    transform: "translate(.868 .879)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2EB54",
    d: "M59.753 37.996c-.299 1.841-1.55 3.345-3.348 3.976l-8.094 2.859 1.25-7.82c.3-1.746 1.448-3.152 3.097-3.832 3.647-1.502 7.644.938 7.095 4.817zM32.77 50.359c-1.848.63-3.798.242-5.196-1.019-3.048-2.617-1.899-7.32 1.9-8.436a5.157 5.157 0 0 1 4.945 1.019l6.446 5.527-8.095 2.91zM50.76 28.671c-3.299 1.356-5.597 4.217-6.147 7.611l-1.149 6.95-5.746-4.945c-2.697-2.328-6.346-3.055-9.743-2.037-7.544 2.279-9.593 11.635-3.748 16.726 2.8 2.424 6.698 3.15 10.244 1.94l7.645-2.715 4.096-1.455 11.892-4.218a9.88 9.88 0 0 0 6.596-7.855c1.1-7.513-6.695-12.96-13.94-10.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M50.152 42.837l-12.321 3.996 12.321-3.995z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M51.948 111.555h8.658V66.6h-8.658z",
    transform: "translate(.868 .879)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9A329",
    d: "M32.902 49.95c-1.87.638-3.84.246-5.253-1.033-3.081-2.657-1.92-7.429 1.92-8.56a5.198 5.198 0 0 1 5 1.032l6.514 5.608-8.181 2.953zm10.808-7.233L37.903 37.7c-2.727-2.362-6.415-3.1-9.85-2.066-7.626 2.311-9.698 11.807-3.788 16.972 2.828 2.46 6.767 3.198 10.354 1.967l7.73-2.754 4.14-1.476-2.779-7.626z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B9862C",
    d: "M85.117 51.88l-4.285-11.76a7.466 7.466 0 0 0-3.883-4.237 7.49 7.49 0 0 0-5.744-.25l-21.179 7.704-1.872 8.618 8.722 10.196 28.241-10.272zM35.754 49.497l-20.722 7.586a7.332 7.332 0 0 0-4.148 3.82 7.382 7.382 0 0 0-.244 5.654l4.189 11.578 27.627-10.116 1.702-8.84-8.404-9.682z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.477 62.817l-5.661 1.665 5.661-1.665z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9A328",
    d: "M56.812 61.696l-7.076 2.558-7.078 2.559-6.825-18.86 2.21-.802 5.017-1.807 6.927-2.507z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2EB54",
    d: "M49.819 64.313l-7.12 2.5-6.866-18.43 2.223-.784 5.048-1.765zM6.752 38.94l1.47 3.478 3.729.277c.28 0 .293.318.146.423L9.223 45.55l.897 3.622c.052.159-.241.357-.363.263l-3.245-1.994-3.235 2.008c-.16.133-.415-.04-.334-.238l.936-3.701-2.953-2.432c-.12-.092-.041-.37.12-.384l3.834-.277 1.43-3.49c.054-.118.403-.118.442.013"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4B754",
    d: "M41.751 16.44l-.485 3.647 3.097 2.035c.245.135.095.41-.085.429l-3.728.67-1.055 3.494c-.033.16-.39.186-.447.05L37.24 23.51l-3.823.139c-.207.033-.34-.233-.171-.363l2.686-2.678-1.332-3.482c-.057-.137.152-.334.299-.267l3.468 1.616 3.01-2.26c.106-.074.407.093.374.224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2EB54",
    d: "M94.678 30.38l-.37 2.965 2.366 1.652c.186.11.073.333-.065.349l-2.849.544-.807 2.84c-.027.13-.3.15-.343.039l-1.383-2.644-2.923.111c-.159.029-.26-.189-.13-.293l2.053-2.176-1.018-2.828c-.045-.111.116-.271.228-.217l2.654 1.312 2.299-1.836c.082-.06.313.076.288.182"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4B754",
    d: "M74.756 1.008l-.24 1.938 1.547 1.08c.12.072.047.218-.043.228l-1.863.356-.53 1.857c-.015.084-.193.1-.223.026L72.5 4.765l-1.912.073c-.103.018-.17-.125-.086-.194l1.345-1.422-.666-1.85c-.03-.071.076-.175.15-.141l1.733.859L74.57.89c.054-.041.205.048.187.118M74.793 20.074c-1.63 0-2.958 1.174-2.958 2.616 0 1.443 1.327 2.617 2.958 2.617 1.631 0 2.96-1.174 2.96-2.617 0-1.442-1.329-2.616-2.96-2.616m0 6.446c-2.386 0-4.328-1.717-4.328-3.83 0-2.112 1.942-3.829 4.328-3.829 2.387 0 4.33 1.717 4.33 3.83 0 2.112-1.943 3.829-4.33 3.829"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2EB54",
    d: "M89.445 12.807a2.062 2.062 0 0 0-2.058 2.058 2.06 2.06 0 0 0 2.058 2.058c1.136 0 2.06-.922 2.06-2.058a2.062 2.062 0 0 0-2.06-2.058m0 5.388a3.334 3.334 0 0 1-3.329-3.33 3.334 3.334 0 0 1 3.33-3.33 3.334 3.334 0 0 1 3.33 3.33 3.334 3.334 0 0 1-3.33 3.33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9A329",
    d: "M7.552 21.856l2.474 2.094 3.307-.831.832-2.925-2.473-2.094-3.308.83-.832 2.926zm2.217 2.999l-3.24-2.742 1.09-3.83 4.33-1.087 3.238 2.74-1.09 3.83-4.328 1.089z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftGoldIcon);
export default __webpack_public_path__ + "static/media/gift-gold-icon.6053c310c3fbc9bbd686a1227b57b86b.svg";
export { ForwardRef as ReactComponent };